import React from 'react'

import { useMerchant } from '@contexts/operator/MerchantContext'
import InventoryMonitorsShow from '@shared/inventory_monitors/InventoryMonitorsShow'
import { useLoaderData } from 'react-router-dom'

import { operatorApiFetch } from '@services/operator/apiService'

export default function OperatorInventoryMonitorsShow() {
  const inventoryMonitor = useLoaderData()
  const { merchants } = useMerchant()

  const merchantOptions = merchants.map(merchant => ({
    label: merchant.name,
    value: merchant.id
  }))

  const inventoryMonitorService = {
    delete: async (id) => {
      const response = await operatorApiFetch(`inventory_monitors/${id}`, {
        method: 'DELETE',
      })
      return response.json()
    }
  }

  return (
    <InventoryMonitorsShow
      inventoryMonitor={inventoryMonitor}
      inventoryMonitorService={inventoryMonitorService}
      role="operator"
      merchants={merchantOptions}
    />
  )
}
